module.exports = __webpack_public_path__ + "img/制造网.e6d32dfb.png";